export default {
  confirmText: '确定',
  cancelText: '取消',
};
